const headerDataJDCG = [
     {
        prop: "quarter",
        label: "季度",
        columnwidth: 140,
      },
      {
        prop: "firstquarter", 
        label: "第一季度",
        columnwidth: 140,
      },
      {
        prop: "secondquarter",
        label: "第二季度",
        columnwidth: 140,
      },
      {
        prop: "thirdquarter",
        label: "第三季度",
        columnwidth: 140,
      },
      {
        prop: "fourthquarter",
        label: "第四季度",
        columnwidth: 140,
      }
];
export default headerDataJDCG;